




















import Vue from 'vue';
import VueSlider from 'vue-slider-component';

export default Vue.extend({
  name: 'Slider',
  components: {VueSlider},
  props: {
    marks: Object,
    value: [Number, String, Array],
    min: Number,
    max: Number,
    interval: {
      default: 1,
      type: Number,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    handleChange(value: number | number[]) {
      this.$emit('change', value);
    },
  },
  computed: {},
});
